// ...existing code...
import { motion } from "motion/react";
import { FC } from "react";
import { MessageRecord } from "../../services/backend/Backend";
import { useMessageClose } from "../../services/backend/backendContextProvider";
import styles from "./Message.module.css";

type MessageProps = {
    message: MessageRecord
}

const itemVariants = {
    hidden: { opacity: 0, y: -8, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.16 } },
    exit: { opacity: 0, y: -8, scale: 0.98, transition: { duration: 0.12 } }
};

export const Message: FC<MessageProps> = ({
    message
}) => {

    const close = useMessageClose(message)

    const extraClasses = (message.classes || []).map(c => (styles as any)[c]).filter(Boolean).join(" ");

    return <motion.div
        className={`${styles.container} ${extraClasses}`}
        onClick={close}
        variants={itemVariants}
        whileTap={{ scale: 0.99 }}
        layout
    >
        {message.text}
    </motion.div>;
}